<script lang="ts" setup>
import { ResultItemInterface } from '@app/components/parts/topBar/search/result.vue';
import ResultComponent from '@app/components/parts/topBar/search/result.vue';
import { inject, Ref } from 'vue';
import { TopBarSearchLangInterface, TalentpoolLink } from './search.vue';
import Button from '@/js/UI-SHARED/components/forms/button.vue';

export interface TopBarSearchResultInterface {
    isOpen: boolean;
    selectedIndex?: number;
    results?: ResultItemInterface[];
    talentpool?: {
        header: string,
        links: TalentpoolLink[],
    };
    moreResultsLink?: TalentpoolLink | null;
    lang: TopBarSearchLangInterface;
}
export type ResultRefsType = Array<InstanceType<typeof ResultComponent>>;
const props = withDefaults(defineProps<TopBarSearchResultInterface>(), {
    selectedIndex: 0,
    results: () => {
        return [];
    },
    moreResultsLink: null,
});
const emit = defineEmits(['update:selectedIndex']);

const resultRefs = inject<Ref<Ref<ResultItemInterface[]>[]>>('resultRefs');
const setSelectedIndex = (index: number) => {
    emit('update:selectedIndex', index);
};
const getRef = (el, index) => {
    if (el) {
        resultRefs.value[index] = el;
    }
};
</script>
<template>
    <div class="pointer-events-none fixed inset-0 z-[200] font-sans">
        <div
            class="@[1024px]/topBar:top-12 @[1024px]/topBar:min-w-[550px] @[1024px]/topBar:max-w-screen-sm @[1024px]/topBar:rounded @[1024px]/topBar:text-sm @[1280px]/topBar:text-base absolute left-1/2 top-14 z-[200] max-h-[50vh] w-full origin-top -translate-x-1/2 overflow-auto bg-white py-2 text-base shadow-lg transition duration-150 ease-in-out"
            :class="
                [
                    props.isOpen
                        ? 'pointer-events-auto translate-y-0 opacity-100'
                        : 'pointer-events-none -translate-y-1 opacity-0',
                ].join(' ')
            "
        >
            <ResultComponent
                v-for="(result, index) in props.results"
                :ref="(el) => getRef(el, index)"
                :key="result.id"
                :result="result"
                :selected-index="selectedIndex"
                :index="index"
                :lang="props.lang"
                @mouseover="setSelectedIndex(index)"
                @mouseout="setSelectedIndex(-1)"
            ></ResultComponent>
            <div
                v-if="props.moreResultsLink"
            >
                <Button
                    :href="props.moreResultsLink.url"
                    class="hover:bg-brand-500 w-full py-4 hover:rounded-none hover:text-white hover:underline"
                    theme="link"
                >
                    <span class="w-full text-left">
                        {{ props.moreResultsLink.label }}
                    </span>
                </Button>
            </div>
            <div
                v-if="props.talentpool"
                class="border-t border-gray-200 px-4 pb-2 pt-4 "
            >
                <div
                    class="px-2 pb-2"
                    v-html="props.talentpool.header"
                ></div>
                <div
                    v-if="props.talentpool.links.length > 0"
                    class="flex flex-wrap items-center gap-3"
                >
                    <Button
                        v-for="link in props.talentpool.links"
                        :key="link.url"
                        :href="link.url"
                        icon="fa fa-search"
                        theme="default"
                    >
                        {{ link.label }}
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>
